/** @jsxImportSource @emotion/react */

import { Button, Card, CardContent, Chip, Grid } from '@material-ui/core'
import { useState } from 'react'

const activities = [
  { person: 'Patryk Płoszaj', project: 'CITO 2.0', task: 'Planowanie sprintu', time: '2 godz. 15 min', color: '#007aff' },
  { person: 'Sandra Płoszaj', project: 'Samfix', task: 'Obsługa klientów', time: '1 godz. 40 min', color: '#7b61ff' },
  { person: 'Adam Drabik', project: 'RDB Technics', task: 'Oferta handlowa', time: '3 godz. 05 min', color: '#13a66a' },
  { person: 'Nela Lewandowska', project: 'Finanse', task: 'Kontrola dokumentów', time: '1 godz. 25 min', color: '#f1970f' },
]

const stats = [
  { label: 'Aktywne projekty', value: '12', note: '+2 w tym miesiącu' },
  { label: 'Czas zarejestrowany dziś', value: '18 h 25 min', note: '4 osoby pracują' },
  { label: 'Wykonanie planu', value: '86%', note: '+8% vs. ubiegły tydzień' },
  { label: 'Otwarte zadania', value: '27', note: '5 z terminem dziś' },
]

const DemoDashboard = () => {
  const [showAll, setShowAll] = useState(false)
  const visibleActivities = showAll ? activities : activities.slice(0, 3)

  return (
    <div css={page}>
      <header css={header}>
        <div>
          <div css={eyebrow}>CITO 2.0 · TRYB DEMO</div>
          <h1>Centrum dowodzenia</h1>
          <p css={muted}>Przykładowe dane operacyjne grupy 77V · niedziela, 6 września 2026</p>
        </div>
        <Chip label='Dane demonstracyjne' color='primary' variant='outlined' />
      </header>

      <main css={content}>
        <Grid container spacing={2}>
          {stats.map((stat) => (
            <Grid item xs={12} sm={6} md={3} key={stat.label}>
              <Card css={card}>
                <CardContent>
                  <div css={statLabel}>{stat.label}</div>
                  <div css={statValue}>{stat.value}</div>
                  <div css={statNote}>{stat.note}</div>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        <Grid container spacing={2} css={{ marginTop: 8 }}>
          <Grid item xs={12} md={8}>
            <Card css={card}>
              <CardContent>
                <div css={sectionHeader}>
                  <div>
                    <h2>Ostatnia aktywność zespołu</h2>
                    <p css={muted}>Dane przykładowe do sprawdzenia widoków i przepływu pracy</p>
                  </div>
                  <Button color='primary' onClick={() => setShowAll(!showAll)}>
                    {showAll ? 'Pokaż mniej' : 'Pokaż wszystko'}
                  </Button>
                </div>
                <div css={activityList}>
                  {visibleActivities.map((activity) => (
                    <div css={activityRow} key={activity.person}>
                      <div css={[avatar, { backgroundColor: activity.color }]}>{activity.person.charAt(0)}</div>
                      <div css={{ flex: 1 }}>
                        <div css={person}>{activity.person}</div>
                        <div css={muted}>{activity.project} · {activity.task}</div>
                      </div>
                      <div css={time}>{activity.time}</div>
                    </div>
                  ))}
                </div>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={4}>
            <Card css={card}>
              <CardContent>
                <h2>Dzisiejszy fokus</h2>
                <div css={focusItem}><span css={dot('#007aff')} />Dokończyć plan sprintu</div>
                <div css={focusItem}><span css={dot('#13a66a')} />Zweryfikować marżę Samfix</div>
                <div css={focusItem}><span css={dot('#f1970f')} />Zamknąć 5 zadań z terminem dziś</div>
                <div css={progressTrack}><div css={progress} /></div>
                <p css={muted}>3 z 5 priorytetów wykonane</p>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </main>
    </div>
  )
}

const page = { minHeight: '100vh', background: '#f5f7fb', color: '#1b2430' }
const header = { padding: '3rem 5vw 2rem', background: '#fff', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '1rem' }
const content = { maxWidth: 1400, margin: '0 auto', padding: '2rem 5vw' }
const card = { height: '100%', borderRadius: 14, boxShadow: '0 6px 24px rgba(27,36,48,.06)' }
const eyebrow = { color: '#007aff', fontSize: '.72rem', fontWeight: 700, letterSpacing: '.12em', marginBottom: '.6rem' }
const muted = { color: '#748091', fontSize: '.88rem', marginTop: '.45rem' }
const statLabel = { color: '#748091', fontSize: '.82rem' }
const statValue = { fontSize: '2rem', fontWeight: 700, marginTop: '.5rem' }
const statNote = { color: '#13a66a', fontSize: '.78rem', marginTop: '.5rem' }
const sectionHeader = { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '1rem' }
const activityList = { marginTop: '1.3rem' }
const activityRow = { display: 'flex', alignItems: 'center', gap: '1rem', padding: '1rem 0', borderBottom: '1px solid #edf0f4' }
const avatar = { width: 38, height: 38, borderRadius: '50%', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700 }
const person = { fontWeight: 600 }
const time = { fontWeight: 600, fontSize: '.9rem', whiteSpace: 'nowrap' }
const focusItem = { display: 'flex', alignItems: 'center', gap: '.7rem', padding: '1rem 0', borderBottom: '1px solid #edf0f4', fontSize: '.9rem' }
const dot = (color) => ({ width: 9, height: 9, borderRadius: '50%', background: color, display: 'inline-block' })
const progressTrack = { height: 8, background: '#e6ebf2', borderRadius: 8, overflow: 'hidden', marginTop: '1.5rem' }
const progress = { width: '60%', height: '100%', background: '#007aff', borderRadius: 8 }

export default DemoDashboard
